/* global System */

export default {
  CtaBox: () => System.import(/* webpackChunkName: "CtaBox" */ './index'),
}
